import React from "react";

export function Shape() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="535"
      height="589"
      viewBox="0 0 535 589"
      fill="none"
    >
      <path
        opacity="0.7"
        d="M672.795 521.502C795.919 462.123 941.766 315.053 575.585 407.022C209.405 498.991 663.448 296.262 821.272 155.066C984.981 8.6419 29.9011 198.484 51.0545 348.604C72.2078 498.724 448.9 347.441 415.406 56.2717"
        stroke="#B91A3D"
        strokeWidth="100"
        strokeLinecap="square"
      />
    </svg>
  );
}

export function ShapeTwo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="846"
      height="579"
      viewBox="0 0 846 579"
      fill="none"
    >
      <path
        className="line-2"
        d="M212.745 593.864C358.949 649.758 822.546 792.326 466.431 560.525C110.316 328.724 477.436 405.184 743.017 461.029C1008.6 516.874 193.087 -40.2421 69.0387 93.5502C-55.0097 227.343 493.91 431.765 484.946 51.9085"
        stroke="url(#paint0_linear_311_1041)"
        strokeWidth="100"
        strokeLinecap="square"
      />
      <defs>
        <linearGradient
          id="paint0_linear_311_1041"
          x1="769.255"
          y1="703.159"
          x2="-110.567"
          y2="48.8101"
          gradientUnits="userSpaceOnUse"
        ></linearGradient>
      </defs>
    </svg>
  );
}
